import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { typography } from '@resiliatech/birdsong'

export const PriorityReviewContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PriorityContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PriorityHeader = styled.h6`
  ${typography.up1.regularSerif}
  margin: 0;
`

export const PriorityDetails = styled(Box)`
  ${typography.baseline.regularSans}
  display: flex;
  flex-direction: column;
`

export const PriorityDetail = styled(Box)`
  align-items: center;
  display: flex;
`
